/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { ProgramSupportSt } from '@ieo/Common/CompLangConfig';
import SingleImage from './SingleImage';

/* Services */
/* Styles */

/**
 * @param {Object} card
 * @param {String} region
 * @param {String} lang
 * @param {String} flexBasis
 * @returns
 */
const ProgramSupportCard = ({ card, lang, region, flexBasis, pageData }) => {
  const descText = render(card?.description);

  return (
    <Box
      w={{ base: '100%', sm: '318px', md: '47%', lg: '30%' }}
      flexBasis={{ base: 'auto', md: 'auto', lg: flexBasis }}
    >
      <Box
        h="auto"
        maxW={{ base: '100%', md: '100%', lg: '318px' }}
        bg="#fff"
        display="flex"
        justifyContent="space-between"
        flexDir="column"
        minH={{ base: '167px', md: '195px' }}
      >
        <Box
          maxW={'100'}
          minH={{ base: '64.26px', md: '72.2px' }}
          alignSelf={'auto'}
          mx={{ base: '23.13px', md: '26.07px' }}
        >
          <SingleImage
            my="0"
            sectionContent={card?.image}
            sync={true}
            w={{ base: '78px', md: '88px' }}
            h={{ base: '78px', md: '88px' }}
            mt={{ base: '-36.5px', md: '-44px' }}
            objectFit="contain"
            px={'0px'}
            mx={'0px'}
          />
        </Box>
        <Box
          w="100%"
          p={0}
          borderLeft={{
            base: lang === 'ar' ? 'none' : '7px solid #A81D28',
            sm: lang === 'ar' ? 'none' : '8px solid #A81D28',
          }}
          borderRight={{
            base: lang === 'ar' ? '7px solid #A81D28' : 'none',
            sm: lang === 'ar' ? '8px solid #A81D28' : 'none',
          }}
          h={{ base: '55%', md: '63%' }}
          minH={{ base: '103px', md: '116px' }}
          pb={{ base: '16.74px', md: '10.8px' }}
          display={'flex'}
          fontFamily="FedraSansStd-book"
          flexDir="column"
          px={{ base: '24px', md: '26px' }}
          dir={lang == 'ar' ? 'rtl' : 'ltr'}
        >
          <Flex w="100%" justifyContent="space-between" flexDirection="column">
            <StructuredTextParser
              className="program-support-card-title"
              fontSize={{ base: '20px', md: '22px' }}
              lineHeight={{ base: '25.2px', md: '27.72px' }}
              display={{ base: 'block', sm: 'block' }}
              {...ProgramSupportSt[lang].stText}
              color="#423E3B !important"
              mt="0"
              str={`${descText} `}
            />
          </Flex>
        </Box>
      </Box>
      <style global jsx>
        {`
          .program-support-card-title strong {
            color: #12166F;
            font-family: FedraSansStd-medium;
            font-weight: 500;
          }
        `}
      </style>
    </Box>
  );
};

export default ProgramSupportCard;
